class CommonchangedtodrgController {
  constructor(
    $scope,
    DTOptionsBuilder,
    DTColumnBuilder,
    User,
    Constants,
    CONST,
    materialButtons,
    datePicker,
    $rootScope,
    FunctionService
  ) {
    this.datatableApi;
    this.user = User.getUser();
    this.name = "Common Changed to DRG";
    this.episodeValue = "";
    this.specialtyString = "";
    this.separationString = "";
    this.locale = "en-au";
    this.url =
      WEBSERVICEURL + "/dataagility/api/service.commonchangetodrg/query?";
    this.initUrl =
      this.url +
      "startDate=" +
      moment()
        .locale(this.locale)
        .subtract(1, "months")
        .startOf("month")
        .format("L") +
      "&endDate=" +
      moment().locale(this.locale).subtract(1, "days").format("L") +
      "";

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
      function (response) {
        $scope.vm.episodeValue =
          response.functionSettings.EpisodeValue.valueString;
        $scope.vm.specialtyString =
          response.functionSettings.SpecialtyString.valueString;
        $scope.vm.separationString =
          response.functionSettings.SeparationString.valueString;
        $scope.vm.functionSettings = response.functionSettings;

        // All Private Clients should be active, All Public should be inactive
        if ($scope.vm.episodeValue === "$") {
          console.log("WIES vars set to private");
          $scope.vm.wiesDefault = "0.00";
          $scope.vm.wiesParseAmount = 2;
        } else {
          console.log("WIES vars set to public");
          $scope.vm.wiesDefault = "0.0000";
          $scope.vm.wiesParseAmount = 4;
        }

        if (
          !(
            $scope.vm.functionSettings.ShowDRGVersion &&
            $scope.vm.functionSettings.ShowDRGVersion.isActive
          )
        ) {
          var drgVersionColumn = $scope.vm.dtColumns.filter(
            (x) => x.mData === "drgVersion"
          );
          var indexOfDRGVersionColumn = $scope.vm.dtColumns.indexOf(
            drgVersionColumn[0]
          );
          $scope.vm.dtColumns.splice(indexOfDRGVersionColumn, 1);
        }

        Constants.campusData().then(function successCallback(response) {
          if (
            $scope.vm.user.role !== "Administrator" &&
            $scope.vm.functionSettings.LimitCampusDropDown &&
            $scope.vm.functionSettings.LimitCampusDropDown.isActive
          ) {
            let campusOptions = [];
            if (typeof $scope.vm.user.campus === "string") {
              campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
            } else {
              campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
            }
            $scope.vm.campusOptions = campusOptions;
            $scope.vm.campus.selectedCampus = campusOptions;
          } else {
            $scope.vm.campusOptions = response;
          }
        });
      }
    );

    materialButtons.render();

    materialButtons.processing();

    datePicker.autoClose($scope);

    $scope.initCallback = function (
      nRow,
      aData,
      iDisplayIndex,
      iDisplayIndexFull
    ) {
      // Datatables has finished init
      // Initialise searching
      if ($scope.vm.datatableApi) return;

      $scope.vm.datatableApi = this.api();

      // Update column headers even when no data returned
      setDtHeaders($scope.vm.datatableApi);

      // setup search filters
      search();

      // set the table to a fixed height, so it never collapsed up and down
      $("#auditTable").closest(".dataTables_scrollBody").height(300);
    };

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption("ajax", {
        headers: {
          Authorization: "Bearer " + $rootScope.globals.currentUser.token,
        },
        url: $scope.vm.initUrl,
        type: "GET",
        error: (xhr, error, thrown) => {
          if (thrown == "Unauthorized") {
            //window.location.replace(window.location.origin + '/login');
            console.log(
              "Unauthorized request with token: ",
              $rootScope.globals.currentUser.token
            );
          }
        },
      })
      .withDisplayLength(CONST.TABLEROWS)
      .withDataProp("data")
      .withOption("processing", true)
      // .withOption('serverSide', true)
      .withOption("sAjaxDataProp", "")
      .withOption("bLengthChange", false)
      .withPaginationType("simple_numbers")
      .withOption("initComplete", $scope.initCallback)
      .withOption("rowCallback", function (row, data, index) {
        // Update column headers if data returned
        setDtHeaders($("#auditTable").DataTable());
      })
      .withOption("scrollY", "300px")
      .withOption("scrollX", "auto")
      .withOption("aaSorting", [[2, "desc"]])
      .withOption("dom", '<"wrapper"rt<"table-footer"iBp>>')
      .withButtons([
        {
          extend: "print",
          text: "",
        },
        {
          extend: "csvHtml5",
          text: "",
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm"),
        },
        {
          extend: "excelHtml5",
          text: "",
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm"),
        },
        {
          text: "",
          action: function (e, dt, node, config) {
            dt.ajax.reload();
          },
        },
      ]);

    this.dtColumns = [
      DTColumnBuilder.newColumn("campus")
        .withTitle("Campus")
        .withOption("defaultContent", "")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("speciality")
        .withTitle("Loading...")
        .withOption("defaultContent", "")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("drgVersion")
        .withTitle("DRG<br>Version")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("drg")
        .withTitle("DRG")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalChangesOfDRG")
        .withTitle("Total Changed to DRG")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("sumTotalWIESChange")
        .withTitle("Loading...")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric")
        .renderWith(function (data, type, full) {
          return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
        }),
      DTColumnBuilder.newColumn("avgChangePerEpisode")
        .withTitle("Average Change per Episode")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric")
        .renderWith(function (data, type, full) {
          return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
        }),
      DTColumnBuilder.newColumn("totalQueryGenerated")
        .withTitle("Query Generated by Coder")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalQueryGeneratedCoder")
        .withTitle("Query Generated by Auditor")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalEpisodeChange")
        .withTitle("Episode Change")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalIncompleteDocumentation")
        .withTitle("Incomplete Documentation")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric"),
    ];

    // Search filters
    this.campus = {
      selectedCampus: [],
    };
    this.campusOptions = [];
    this.specialty = {
      selectedSpecialty: [],
    };
    this.specialtyOptions = {};
    this.auditCriteria = {
      selectedCriteria: [],
    };
    this.auditCriteriaOptions = {};

    Constants.getDivisionAndSpecialtyData().then(function successCallback(
      response
    ) {
      $scope.vm.specialtyOptions = response.specialties;
      filterSpecialty($scope.vm.specialtyOptions);
    });

    this.startDatePicker = {
      input: {
        date: moment()
          .locale(this.locale)
          .subtract(1, "months")
          .startOf("month"),
        dateFormatted: moment()
          .locale(this.locale)
          .subtract(1, "months")
          .startOf("month")
          .format("L"),
      },
    };
    this.endDatePicker = {
      input: {
        date: moment().locale(this.locale).subtract(1, "days"),
        dateFormatted: moment()
          .locale(this.locale)
          .subtract(1, "days")
          .format("L"),
      },
    };

    // callbacks for lx-selects and lx-date-picker
    this.campusCallback = campusCallback;
    function campusCallback(_newValue, _oldValue) {
      filterDate();
    }

    this.specialtyCallback = specialtyCallback;
    function specialtyCallback(_newValue, _oldValue) {
      filterDate();
    }

    function selectFilter(column, filter) {
      if (filter) {
        // convert array to datatables permissable regex string
        filter = filter.join("|");

        if (filter !== "") filter = "^" + filter + "$";

        var auditTable = $scope.vm.datatableApi;

        auditTable.columns(column).search(filter, true, false).draw();
      }
    }

    function setDtHeaders(table) {
      $(table.column(getIndexOfColumn('speciality')).header()).html($scope.vm.specialtyString);
      $(table.column(getIndexOfColumn('sumTotalWIESChange')).header()).html(
        "Total " + $scope.vm.episodeValue + " Change"
      );
    }


    function getIndexOfColumn(columnName) {
      const selectedColumn = $scope.vm.dtColumns.filter(x => x.mData === columnName);
      return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
    }

    function filterCampus(modifier) {
      $scope.vm.campus.selectedCampus = [];
      if (modifier === "add") {
        $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
      }
    }

    function filterSpecialty(swap) {
      $scope.vm.specialty.selectedSpecialty = [];
      if (swap === "add") {
        $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
      }
    }

    function setDefaultDate() {
      $scope.vm.startDatePicker.input.date = moment()
        .locale($scope.vm.locale)
        .subtract(1, "months")
        .startOf("month");
      $scope.vm.startDatePicker.input.dateFormatted = moment()
        .locale($scope.vm.locale)
        .subtract(1, "months")
        .startOf("month")
        .format("L");

      $scope.vm.endDatePicker.input.date = moment()
        .locale($scope.vm.locale)
        .subtract(1, "days");
      $scope.vm.endDatePicker.input.dateFormatted = moment()
        .locale($scope.vm.locale)
        .subtract(1, "days")
        .format("L");
    }

    function filterDate() {
      var startDate = $scope.vm.startDatePicker.input.dateFormatted,
        endDate = $scope.vm.endDatePicker.input.dateFormatted,
        campus = "";
      if (
        $scope.vm.functionSettings.LimitCampusDropDown &&
        $scope.vm.functionSettings.LimitCampusDropDown.isActive
      ) {
        if (
          $scope.vm.user.role !== "Administrator" &&
          $scope.vm.campus.selectedCampus.length === 0
        ) {
          campus = $scope.vm.user.campus;
        } else {
          campus = $scope.vm.campus.selectedCampus;
        }
      } else {
        campus = $scope.vm.campus.selectedCampus;
      }
      var url =
        $scope.vm.url +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&campus=" +
        checkParam(campus) +
        "&specialty=" +
        checkParam($scope.vm.specialty.selectedSpecialty);
      $scope.vm.datatableApi.ajax.url(url).load().draw();
    }

    function checkParam(param) {
      if (param.length !== 0) {
        return encodeURIComponent(param.join());
      } else {
        return "";
      }
    }

    function search() {
      // delete any global searches previously applied
      if ($.fn.dataTable.ext.search.length === 1)
        $.fn.dataTable.ext.search.shift();

      var auditTable = $scope.vm.datatableApi;
      var clearAuditTable = auditTable.search("").draw();

      filterSpecialty("minus");

      filterDate();

      // re-draw tabele on datepicker close
      $scope.$on("lx-date-picker__close-start", function (e, id) {
        var newUrl =
          $scope.vm.url +
          "startDate=" +
          $scope.vm.startDatePicker.input.dateFormatted +
          "&endDate=" +
          $scope.vm.endDatePicker.input.dateFormatted +
          "";
        $scope.vm.datatableApi.ajax.url(newUrl).load();
      });

      // Trigger filtering
      // $('.reports__filters').find('div').first().find('div:last-child').click();
    }

    // bind the datatable instance to an object to monitor loading
    this.dtInstanceCallback = dtInstanceCallback;

    function dtInstanceCallback(dtInstance) {
      $scope.dtInstance = dtInstance._renderer;
    }

    // bind filter swap
    this.filterSwap = filterSwap;

    function filterSwap(thisFilter, thisModifier) {
      switch (thisFilter) {
        case "specialty":
          if (thisModifier === "add") {
            filterSpecialty("add");
          } else {
            filterSpecialty("minus");
          }
          break;
        case "campus":
          if (thisModifier === "add") {
            filterCampus("add");
          } else {
            filterCampus("minus");
          }
          break;
        default:
          break;
      }
    }
  }
}

export default CommonchangedtodrgController;



// WEBPACK FOOTER //
// ./client/app/common/reports/commonchangedtodrg/commonchangedtodrg.controller.js